import moment from "moment";
import useSVG from "../../../../../hooks/useSVG";

function WaitUp({ button, billing }) {

    const { UseCancellationSVG } = useSVG();

    return (
        <div id="wait-up">
            <div className="cmp-header">
                <p>Wait Up!</p>

                <div className="cmp-subheader">
                    You're currently using indi with our <bold>{`${billing?.currentPlan?.name}`}</bold> plan. Your subscription expires on <bold>{moment(new Date(billing.currentPeriodEndsAt)).format("LL")}</bold>. If you
                    stay with indi, you'll continue to have access to:
                </div>
            </div>
            <div id="cmp-content">

                <div id="app-assets">
                    <div>
                        <div className="aa-svg-container">
                            {UseCancellationSVG("benefit1")}
                        </div>
                        <p>200+ workouts</p>
                    </div>

                    <div>
                        <div className="aa-svg-container">
                            {UseCancellationSVG("benefit2")}
                        </div>
                        <p>Expertise provided by licensed Physical Therapists</p>
                    </div>

                    <div>
                        <div className="aa-svg-container">
                            {UseCancellationSVG("benefit3")}
                        </div>
                        <p>Workouts under 30 minutes to fit any schedule</p>
                    </div>

                    <div>
                        <div className="aa-svg-container">
                            {UseCancellationSVG("benefit4")}
                        </div>
                        <p>A variety of workouts that target strength, mobility, and athletics</p>
                    </div>
                </div>

                <div className="cmp-btn-div cancel-v2-button">
                    {
                        button
                    }
                </div>
            </div>
        </div>
    );
}

export default WaitUp;